import { USER_TYPE, STATUS_CODES } from "../../../constants/comman";
import { getUserType } from "../../../utils";
import { ContentAction } from "../types/ContentAction";
import ContentData from "../types/ContentData";
import ContentFromDataDefault from "../types/ContentFromDataDefault";
import _ from 'lodash';

interface ContentTypeState {
  list: ContentData[];
  statusCode: number;
  isFirstLoad: boolean;
  counter: number;
  error: string | null;
  lockData: any;
  formData: any;
  assignTestInfo: any;
  benchMarkInfo: any;
  goalLevels: any;
  updateBenchMarkResponse: any;
  isTemplateChanged: boolean;
  isQuestionUpdated: boolean;
  requiresForceSaveForChallenge: boolean;
  contentSuggestions:any,
  loading:boolean  
}

const initialState: ContentTypeState = {
  list: [],
  statusCode: STATUS_CODES.SUCCESS,
  isFirstLoad: true,
  counter: 0,
  lockData: {},
  error: null,
  formData: ContentFromDataDefault,
  assignTestInfo: {},
  benchMarkInfo: {},
  updateBenchMarkResponse: {},
  goalLevels: {},
  isTemplateChanged: false,
  isQuestionUpdated: false,
  requiresForceSaveForChallenge: false,
  contentSuggestions:{},
  loading:false
};

const contentReducers = (state = initialState, action: ContentAction) => {
  switch (action.type) {
    case "CONTENT_DATA_SUCCESS": {
      return {
        ...state,
        list: action.data,
        statusCode: action.statusCode,
        counter: state.counter + 1,
        isFirstLoad: state.counter > 0 ? false : !!!getUserType(USER_TYPE.STUDENT),
      };
    }
    case "CONTENT_DATA_FAILED": {
      return { ...state, list: [] };
    }
    case "CLEAR_CONTENT_LIST": {
      return { ...state, list: [] };
    }
    case "SET_REQUIRES_FORCE_SAVE_FOR_CHALLENGE": {
      return { ...state, requiresForceSaveForChallenge: action.data };
    }
    case "FETCH_EDIT_LOCK_INFO_SUCCESS": {
      const { responseMessage, responseObject } = action.data;
      const lockData = {
        message: responseMessage,
        ...responseObject,
      };
      return { ...state, lockData };
    }
    case "FETCH_EDIT_LOCK_INFO_FAILED": {
      return { ...state, lockData: {} };
    }
    case "RESET_EDIT_LOCK_INFO": {
      return { ...state, lockData: {} };
    }
    case "UPDATE_CONTENT": {
      return { ...state, formData: action.data };
    }
    case "ASSIGN_TEST_SUCCESS": {
      const { assignTestResponse, teacherTokenResponse } = action.data;
      const { responseMessage, responseObject } = assignTestResponse;
      const teacherToken = _.get(teacherTokenResponse, 'responseObject.authToken');
      const assignTestInfo = {
        message: responseMessage,
        teacherToken,
        ...responseObject,
      };
      return { ...state, assignTestInfo };
    }
    case "ASSIGN_TEST_FAILED": {
      return { ...state, error: action.error };
    }
    case "FETCH_BENCHMARK_SUCCESS": {
      let { responseObject } = action.data;
      /* TODO: remove later */
      // responseObject = {
      //   hasBenchmarks: true,
      //   benchmarks: [
      //     {
      //       goalLevel: {
      //         id: "5fca13ff399abf7f5984ab7d",
      //         name: "2-101"
      //       },
      //       marks: {
      //         minimum: 0,
      //         maximum: 19
      //       }
      //     }
      //   ]
      // };
      return { ...state, benchMarkInfo: { ...responseObject } };
    }
    case "RESET_BENCHMARK": {
      return { ...state, benchMarkInfo: {} };
    }
    case "UPDATE_BENCHMARK_SUCCESS": {
      const { statusCode } = action.data;
      return {
        ...state,
        updateBenchMarkResponse: {
          message: action.data.responseMessage,
          statusCode,
        },
      };
    }
    case "FETCH_GOAL_LEVELS_SUCCESS": {
      const { responseObject } = action.data;
      /* TODO: remove later */
      // responseObject.goalLevels.push({
      //   _id: "5fca13ff399abf7f5984ab7d9",
      //   name: "1-201",
      //   scale: 99
      // });
      // responseObject.goalLevels.push({
      //   _id: "5fca13ff399abf7f5984ab7d2",
      //   name: "3-201",
      //   scale: 33
      // });
      // responseObject.goalLevels.push({
      //   _id: "5fca13ff399abf7f5984ab7d0",
      //   name: "4-201",
      //   scale: 22
      // });
      // responseObject.goalLevels.push({
      //   _id: "5fca13ff399abf7f5984ab7r0",
      //   name: "4-201",
      //   scale: 11
      // });
      return { ...state, goalLevels: { ...responseObject } };
    }
    case "TEMPLATE_CHANGED": {
      return { ...state, isTemplateChanged: action.data };
    }
    case "QUESTION_COMPLETED": {
      return { ...state, isQuestionUpdated: action.data };
    }
    case "SET_CONTENT_SUGGESTIONS": {
      return { ...state,loading:true};
    }
    case "SET_CONTENT_SUGGESTIONS_SUCCESS": {
      return { ...state, contentSuggestions:action.data,loading:false};
    }
    case "SET_CONTENT_SUGGESTIONS_FAILURE": {
      return { ...state,loading:false};
    }
    default:
      return state;
  }
};

export default contentReducers;
